import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ShoppingBag, Search, Menu, X, User } from "lucide-react";
import { useCart } from "../context/CartContext";
import { BRAND, HANDLES, logoImage } from "../mock/mock";

const navLinks = [
  { label: "Shop", to: "/shop" },
  { label: "1.RDR", to: `/product/${HANDLES.rdr}` },
  { label: "2.ROI VUE", to: `/product/${HANDLES.roivue}` },
  { label: "Kontakt", to: "/impressum" },
];

const Header = () => {
  const { count, setIsOpen } = useCart();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      {/* Announcement bar */}
      <div className="bg-gold text-[#14110c] text-[11px] tracking-luxe uppercase text-center py-2 font-medium">
        Kostenloser Versand ab €99 · Limited Editions — nur 750 Stück
      </div>

      <header
        className={`sticky top-0 z-50 transition-all duration-500 ${
          scrolled
            ? "bg-[#ffffff]/95 backdrop-blur-md border-b border-[#e7e0d3]"
            : "bg-transparent border-b border-transparent"
        }`}
      >
        <div className="max-w-[1400px] mx-auto px-5 lg:px-10">
          <div className="flex items-center justify-between h-20">
            {/* Left nav (desktop) */}
            <nav className="hidden lg:flex items-center gap-8 flex-1">
              {navLinks.map((l) => (
                <Link
                  key={l.label}
                  to={l.to}
                  className="text-[12px] tracking-[0.2em] uppercase text-[#4a463c] hover:text-gold transition-colors hover-underline"
                >
                  {l.label}
                </Link>
              ))}
            </nav>

            {/* Mobile menu btn */}
            <button
              className="lg:hidden text-[#17140f]"
              onClick={() => setMenuOpen(true)}
              aria-label="Menü öffnen"
            >
              <Menu size={24} />
            </button>

            {/* Logo */}
            <Link
              to="/"
              className="flex items-center gap-3 absolute left-1/2 -translate-x-1/2"
            >
              <img
                src={logoImage}
                alt="Roi des Rois Monogramm"
                className="hidden md:block h-11 w-11 object-cover rounded-sm border border-[#dcd4c5]"
              />
              <div className="flex flex-col items-center">
                <span className="font-serif text-2xl lg:text-[28px] tracking-[0.18em] text-[#17140f] leading-none">
                  {BRAND.name}
                </span>
                <span className="text-[9px] tracking-[0.4em] text-gold uppercase mt-1">
                  Paris
                </span>
              </div>
            </Link>

            {/* Right icons */}
            <div className="flex items-center gap-5 flex-1 justify-end">
              <button
                className="hidden sm:block text-[#4a463c] hover:text-gold transition-colors"
                aria-label="Suche"
              >
                <Search size={20} />
              </button>
              <button
                className="hidden sm:block text-[#4a463c] hover:text-gold transition-colors"
                aria-label="Konto"
              >
                <User size={20} />
              </button>
              <button
                onClick={() => setIsOpen(true)}
                className="relative text-[#17140f] hover:text-gold transition-colors"
                aria-label="Warenkorb"
              >
                <ShoppingBag size={22} />
                {count > 0 && (
                  <span className="absolute -top-2 -right-2 bg-gold text-[#14110c] text-[10px] font-semibold rounded-full w-[18px] h-[18px] flex items-center justify-center">
                    {count}
                  </span>
                )}
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Mobile drawer */}
      <div
        className={`fixed inset-0 z-[60] lg:hidden transition-opacity duration-300 ${
          menuOpen ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
        }`}
      >
        <div
          className="absolute inset-0 bg-black/70"
          onClick={() => setMenuOpen(false)}
        />
        <div
          className={`absolute left-0 top-0 h-full w-[80%] max-w-sm bg-[#ffffff] border-r border-[#e7e0d3] p-8 transition-transform duration-500 ${
            menuOpen ? "translate-x-0" : "-translate-x-full"
          }`}
        >
          <div className="flex justify-between items-center mb-12">
            <div className="flex items-center gap-3">
              <img
                src={logoImage}
                alt="Roi des Rois"
                className="h-10 w-10 object-cover rounded-sm border border-[#dcd4c5]"
              />
              <span className="font-serif text-xl tracking-[0.18em] text-gold">
                {BRAND.name}
              </span>
            </div>
            <button onClick={() => setMenuOpen(false)} className="text-[#17140f]">
              <X size={24} />
            </button>
          </div>
          <nav className="flex flex-col gap-6">
            {navLinks.map((l) => (
              <button
                key={l.label}
                onClick={() => {
                  navigate(l.to);
                  setMenuOpen(false);
                }}
                className="text-left text-sm tracking-[0.2em] uppercase text-[#17140f] hover:text-gold transition-colors"
              >
                {l.label}
              </button>
            ))}
          </nav>
        </div>
      </div>
    </>
  );
};

export default Header;
